import { render, staticRenderFns } from "./CreateAlertModal.vue?vue&type=template&id=40c86d95&"
import script from "./CreateAlertModal.vue?vue&type=script&lang=js&"
export * from "./CreateAlertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports